"use client";

import { useState } from "react";
import { LeadForm } from "@/components/ui/lead-form";

export function VideoShowcaseCTA() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <>
      <div className="text-center mt-8 sm:mt-12">
        <p className="text-muted-foreground mb-4 sm:mb-6 px-4 sm:px-0">
          Ready to transform your jewelry catalog?
        </p>
        <div
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive shadow-xs h-10 rounded-md has-[>svg]:px-4 text-base sm:text-lg px-6 sm:px-8 py-4 sm:py-6 bg-foreground text-background hover:bg-foreground/70 cursor-pointer"
          onClick={() => setIsFormOpen(true)}
        >
          Join Waitlist
        </div>
      </div>

      <LeadForm
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        title="Join PhotoZoot Waitlist"
        buttonText="Submit & Join Waitlist"
      />
    </>
  );
}
